/**
 * Create Stores context for custom hook
 */

import { createContext } from 'react'

const StoresContext = createContext({
  stores: [],
  storesReady: false,
  fetchStore: () => {},
  fetchStoreByCode: () => {},
  fetchStores: () => { },
  fetchStoreDateTimeInformation: () => { },
})

export default StoresContext
